import cx from 'classnames';
import Icon from 'components/Icon/Icon.tsx';
import type { BottomMenuItem as BottomMenuItemType } from 'config/types';
import { useTranslation } from 'utils/translations';

import LinkMenuItem from './LinkMenuItem';
import SandwichMenuItem from './SandwichMenuItem';

import styles from './BottomMenu.module.scss';

const menuItemComponents = {
  link: LinkMenuItem,
  sandwichButton: SandwichMenuItem,
} as const;

const BottomMenuItem = ({
  id,
  label,
  type,
  icon,
  ...props
}: BottomMenuItemType) => {
  const badge = null; // should be implemented in the future
  const title = useTranslation(label);

  const Component = menuItemComponents[type];

  return (
    <Component
      className={(active: boolean) =>
        cx(styles.item, { [styles.active]: active })
      }
      {...props}
    >
      <div className={styles['icon-wrapper']}>
        <Icon name={icon} />
        {badge && <span className={styles.badge}>{badge}</span>}
      </div>
      <span className={styles.title}>{title}</span>
    </Component>
  );
};

export default BottomMenuItem;
